document.addEventListener('DOMContentLoaded', function () {
    const rodzajOponSelect = document.querySelector('#rodzaj-opon-select');
    const rzezbaBieznikaSelect = document.querySelector('#rzezba-bieznika-select');
    const rozmiarOponSelect = document.querySelector('#rozmiar-opony-select');

    if (rzezbaBieznikaSelect) {
        let currentTireTypeId;
        let currentTireTypeIdAndTreadIdOfSelectedTireSize;
        let currentTireTypeIdOfSelectedTread;

        const tireTypeOptions = rodzajOponSelect.childNodes;
        const tireSizeOptions = rozmiarOponSelect.childNodes;
        const tireTreadOptions = rzezbaBieznikaSelect.childNodes;

        const OPTION_STRING = 'option'.toUpperCase();
        const DEFAULT_TIRE_SIZE = 'dowolny';
        const DEFAULT_TREAD = 'dowolna';
        const DISPLAY_BLOCK = 'block';
        const DISPLAY_NONE = 'none';

        const showOptions = (options) => {
            options.forEach((item) => {
                if (item.nodeName === OPTION_STRING) {
                    item.style.display = 'block';
                }
            });
        };

        const getIdsFromString = (string) => {
            return string.split(' ').filter((n) => n > 0);
        };

        rodzajOponSelect.addEventListener('change', (e) => {
            currentTireTypeId = e.target.value;
            currentTireTypeIdOfSelectedTread = undefined;
            rozmiarOponSelect.value = '';
            rzezbaBieznikaSelect.value = '';
            if (e.target.value === '') {
                if (tireSizeOptions.length > 0) showOptions(tireSizeOptions);
                if (tireTreadOptions.length > 0) showOptions(tireTreadOptions);
            }
            handleCurrentSearchValues();
        });

        rozmiarOponSelect.addEventListener('change', (e) => {
            currentTireTypeIdAndTreadIdOfSelectedTireSize = e.target.value;
            handleCurrentSearchValues();
        });

        rzezbaBieznikaSelect.addEventListener('change', (e) => {
            currentTireTypeIdOfSelectedTread = e.target
                .querySelector('option:checked')
                .getAttribute('parent-id');
            currentTireTypeId = currentTireTypeIdOfSelectedTread;
            handleCurrentSearchValues();
        });

        const handleCurrentSearchValues = () => {
            if (currentTireTypeId) {
                if (tireSizeOptions.length > 0) {
                    tireSizeOptions.forEach((item) => {
                        if (item.nodeName === OPTION_STRING) {
                            const ids = getIdsFromString(item.value);
                            let defaultOptionItem;

                            if (item.textContent === DEFAULT_TIRE_SIZE) {
                                defaultOptionItem = item;
                            }

                            item.style.display = DISPLAY_BLOCK;

                            if (ids.some((id) => id === currentTireTypeId)) {
                                // console.log(item);
                            } else {
                                if (item.textContent !== DEFAULT_TIRE_SIZE) {
                                    item.style.display = DISPLAY_NONE;
                                    item.selected = false;
                                    currentTireTypeIdAndTreadIdOfSelectedTireSize = undefined;
                                    if (defaultOptionItem) {
                                        defaultOptionItem.selected = true;
                                    }
                                }
                            }
                        }
                    });
                }
                if (tireTreadOptions.length > 0) {
                    tireTreadOptions.forEach((item) => {
                        if (item.nodeName === OPTION_STRING) {
                            const ids = getIdsFromString(rozmiarOponSelect.value);

                            let defaultOptionItem;

                            if (item.textContent === DEFAULT_TREAD) {
                                defaultOptionItem = item;
                            }

                            item.style.display = DISPLAY_BLOCK;

                            if (
                                (item.getAttribute('parent-id') === currentTireTypeId &&
                                    ids.some((id) => id === item.value)) ||
                                (item.getAttribute('parent-id') === currentTireTypeId &&
                                    rozmiarOponSelect.value === '')
                            ) {
                                // console.log(item);
                            } else {
                                if (item.textContent !== DEFAULT_TREAD) {
                                    item.style.display = DISPLAY_NONE;
                                    item.selected = false;
                                    if (defaultOptionItem) {
                                        defaultOptionItem.selected = true;
                                    }
                                }
                            }
                        }
                    });
                }
            }

            if (currentTireTypeIdAndTreadIdOfSelectedTireSize) {
                if (tireTypeOptions.length > 0) {
                    tireTypeOptions.forEach((item) => {
                        if (item.nodeName === OPTION_STRING) {
                            const ids = getIdsFromString(
                                currentTireTypeIdAndTreadIdOfSelectedTireSize,
                            );

                            item.selected = false;

                            if (ids.some((id) => id === item.value)) {
                                item.selected = true;
                                currentTireTypeId = item.value;

                                tireSizeOptions.forEach((option) => {
                                    if (option.nodeName === OPTION_STRING) {
                                        const optionValueIds = getIdsFromString(option.value);

                                        if (optionValueIds.some((id) => id === currentTireTypeId)) {
                                            // console.log(option);
                                        } else {
                                            if (option.textContent !== DEFAULT_TIRE_SIZE) {
                                                option.style.display = DISPLAY_NONE;
                                                option.selected = false;
                                            }
                                        }
                                    }
                                });
                            }

                            tireTreadOptions.forEach((option) => {
                                if (option.nodeName === OPTION_STRING) {
                                    if (ids.some((id) => id === option.value)) {
                                        // console.log(option);
                                    } else {
                                        if (option.textContent !== DEFAULT_TREAD) {
                                            option.style.display = DISPLAY_NONE;
                                            option.selected = false;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            }

            if (currentTireTypeIdOfSelectedTread) {
                if (tireTypeOptions.length > 0 && tireSizeOptions.length > 0) {
                    tireTypeOptions.forEach((item) => {
                        if (item.nodeName === OPTION_STRING) {
                            if (item.value === currentTireTypeIdOfSelectedTread) {
                                item.selected = true;
                            }
                        }
                    });
                }
            }
        };

        // Akcja Pokaż wyniki (przekierowanie do kategorii na podstawie wyborówd)
        const searchTaxonomyButton = document.querySelector('#search__taxonomy');

        searchTaxonomyButton.addEventListener('click', function () {
            const selectedRzezba = rzezbaBieznikaSelect.value;
            const selectedRodzaj = rodzajOponSelect.value;

            let redirectURL = null;

            if (selectedRzezba || selectedRodzaj) {
                const selectedOption = selectedRzezba
                    ? `option[value="${selectedRzezba}"]`
                    : `option[value="${selectedRodzaj}"]`;

                const selectedOptionElement = document.querySelector(selectedOption);
                redirectURL = selectedOptionElement.getAttribute('data-url');
            }

            if (redirectURL) {
                const selectedRozmiarOptions = $(rozmiarOponSelect).find('option:checked');
                const selectedRozmiarTexts = Array.from(selectedRozmiarOptions).map(
                    (option) => option.textContent,
                );

                if (
                    selectedRozmiarTexts.length > 0 &&
                    !selectedRozmiarTexts.includes('dowolny') &&
                    !selectedRozmiarTexts.includes('')
                ) {
                    const rozmiarQueryParam = `rozmiar=${encodeURIComponent(
                        selectedRozmiarTexts.join(','),
                    )}`;

                    if (redirectURL.includes('?')) {
                        redirectURL += '&' + rozmiarQueryParam;
                    } else {
                        redirectURL += '?' + rozmiarQueryParam;
                    }
                }

                window.location.href = redirectURL;
            } else {
                // Obsługa w przypadku braku URL do przekierowania
            }
        });

        // Zmiana kategorii i rozmiaru w wyszukiwarce po załadowaniu strony kategorii lub produktu.

        const customPostSize = document.body.getAttribute('data-size-of-post');
        const customPostCategoryIDs = document.body.getAttribute('data-custom-post-category-ids');
        const customSingleTireSize = document.getElementById('tire_size__info');

        if (customPostCategoryIDs) {
            const categoryIDs = customPostCategoryIDs.split('-');

            categoryIDs.forEach((categoryID) => {
                const matchingRodzajOption = Array.from(rodzajOponSelect.options).find(
                    (option) => option.value === categoryID,
                );
                const matchingRzezbaOption = Array.from(rzezbaBieznikaSelect.options).find(
                    (option) => option.value === categoryID,
                );

                if (matchingRodzajOption) {
                    rodzajOponSelect.value = categoryID;
                    rodzajOponSelect.dispatchEvent(new Event('change'));
                }

                if (matchingRzezbaOption) {
                    rzezbaBieznikaSelect.value = categoryID;
                    rzezbaBieznikaSelect.dispatchEvent(new Event('change'));
                }
            });
        }

        if (customPostSize) {
            const options = rozmiarOponSelect.options;
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (option.getAttribute('data-size') === customPostSize) {
                    option.selected = true;
                    rozmiarOponSelect.dispatchEvent(new Event('change'));
                    break;
                }
            }
        }

        if (customSingleTireSize) {
            const options = rozmiarOponSelect.options;
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (
                    option.getAttribute('data-size') ===
                    customSingleTireSize.getAttribute('data-size')
                ) {
                    option.selected = true;
                    rozmiarOponSelect.dispatchEvent(new Event('change'));
                    break;
                }
            }
        }
    }
});
